import React from 'react'
import { useNavContext } from '../useNavContext'
import { MobileSubMenuProps } from '../ContentfulNavigation'
import _helpers from '@toasttab/shared/src/globals/_helpers'
import ShowcaseEntry from '../ShowcaseEntry'
import SubMenuEntry from '../SubMenuEntry'
import MobileChildMenu from './MobileChildMenu'

// Multi-use component that handles subMenu navigation for main nav categories and the region switcher
// Styling and behavior will be the same, but specific funcionality (menu clicks, etc) and content will be different
// This is effectively just a UI wrapper that handles styling, while content and state management is handled by different parents
const MobileSubMenu = ({
  handleCloseButton,
  showcaseEntries,
  subMenus,
  title
}: MobileSubMenuProps) => {
  const { selectedParentMenu, setSelectedParentMenu } = useNavContext()

  const handleBackButton = () => {
    setSelectedParentMenu(null)
  }
  const sortedSubMenus = subMenus?.columns?.flat()
  if (sortedSubMenus?.some((sub) => sub.mobileOrder)) {
    sortedSubMenus.sort((a, b) => a.mobileOrder - b.mobileOrder)
  }

  return (
    <MobileChildMenu
      ariaLabel={`Toast ${title} Dropdown Menu`}
      handleBackButton={handleBackButton}
      handleCloseButton={handleCloseButton}
      id={`${title.replace(/\s/g, '-')}-mobile-menu`}
      isOpen={selectedParentMenu === title}
      showFooterMenu
      title={title}
    >
      <>
        {showcaseEntries?.length ? (
          <div className='mb-6'>
            {showcaseEntries.map((showcase: any) => (
              <ShowcaseEntry
                key={showcase.title}
                menuType='mobile'
                {...showcase}
              />
            ))}
          </div>
        ) : null}
        {sortedSubMenus?.map((submenu: any) => (
          <SubMenuEntry key={submenu?.title} menuType='mobile' {...submenu} />
        ))}
      </>
    </MobileChildMenu>
  )
}

export default MobileSubMenu
